import { useState } from 'react'
import { RosterSelector } from 'components/RosterSelector'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Button, Text } from 'ui'
import { SelectedRosters } from './SelectedRosters'
import { useShiftEditor } from 'pages/ShiftEditorPage/useShiftEditor'

export function Roster() {
  const { control, watch } = useFormContext()
  const [open, setOpen] = useState(false)
  const rosterIds = watch('rosterIds')
  const hasSelectedRosters = (rosterIds ?? []).length > 0
  const { isOnDemandDeliveryBlock } = useShiftEditor()
  const defaultText = isOnDemandDeliveryBlock
    ? 'A text message will be sent to the delivery drivers on your chosen Lists, inviting them to accept this shift.'
    : 'A text message will be sent to the workers on your chosen Lists, inviting them to accept this shift.'

  return (
    <Box>
      <Text my={2} mb={3}>
        {defaultText}
      </Text>
      {!hasSelectedRosters ? (
        <Button width={[1, 200]} onClick={() => setOpen(true)}>
          Add Lists
        </Button>
      ) : null}
      <SelectedRosters
        openSelector={() => setOpen(true)}
        isOnDemandDeliveryBlock={isOnDemandDeliveryBlock}
      />
      <Controller
        render={({ field: { value, onChange } }) => (
          <RosterSelector
            open={open}
            onClose={() => setOpen(false)}
            selected={value}
            isOnDemandDeliveryBlock={isOnDemandDeliveryBlock}
            onChange={(selected) => {
              onChange(selected)
              setOpen(false)
            }}
          />
        )}
        name={'rosterIds'}
        control={control}
      />
    </Box>
  )
}
